import ToDoContainer from "../../../Components/Applications/ToDo/ToDoContainer";

const ToDo = () => {
  return <ToDoContainer />;
};

export default ToDo;
